import { render, staticRenderFns } from "./_SupportCallbackResult.vue?vue&type=template&id=a67b42f4&scoped=true"
import script from "./_SupportCallbackResult.vue?vue&type=script&lang=js"
export * from "./_SupportCallbackResult.vue?vue&type=script&lang=js"
import style0 from "./_SupportCallbackResult.vue?vue&type=style&index=0&id=a67b42f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b42f4",
  null
  
)

export default component.exports